/** @jsxImportSource @emotion/react */
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { SpinnerBlock } from "../common/Spinner";
import { EmptyState } from "../../components/EmptyState";
import { useListKioskConfigurations } from "./service/kiosk-configuration-api";
import { MutateKioskConfigurationSelector } from "./components/MutateKioskConfigurationSelector";
import { KioskConfigurationsTable } from "./components/KioskConfigurationsTable";
import { useHandleFetchError } from "../../error-handler";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const KioskConfigurationsList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data, isLoading, error } = useListKioskConfigurations(
    organizationKeyName
  );

  useHandleFetchError(error);

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Kiosk configurations"
          subtitle="Manage all of your kiosk configurations"
        >
          <MutateKioskConfigurationSelector />
        </PageHeader>
        {data?.length === 0 || !data ? (
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <EmptyState
              title="No kiosk configurations created yet"
              subtitle="Create your first kiosk configuration by pressing on create kiosk configuration in top right corner"
            />
          </CardBody>
        ) : (
          <KioskConfigurationsTable kioskConfigurations={data} />
        )}
      </CardContainer>
    </PageWrapper>
  );
};
